import { Ifilter } from "../../Interfaces/filter";
import { ICrearIncidente, IEditIncidente, IIncidenteOculto } from "../../Interfaces/hazard/IHazard";
import { fetchListVerificacion } from "../http-common";

const Incidente = "GrupoIncidente";

const ComboGrupoIncidente = (request: Ifilter, controller = new AbortController()) => {
    return fetchListVerificacion.get(`${Incidente}/Combo`, {
        params: request,
        signal: controller.signal,
    });
};
const ListarGrupoIncidente=(request: Ifilter)=>{
    return fetchListVerificacion.post(`${Incidente}/ListarIncidentes`,request)
}
const CrearIncidente=(request:ICrearIncidente)=>{
    return fetchListVerificacion.post(`${Incidente}/CrearIncidente`,request)
}
const EditarIncidente=(request:IEditIncidente)=>{
    return fetchListVerificacion.put(`${Incidente}/ActualizarIncidente`,request)
}
const OcultoIncidente=(request:IIncidenteOculto)=>{
    return fetchListVerificacion.put(`${Incidente}/OcultarIncidente`,request)
}
const GrupoIncidenteService = {
    ComboGrupoIncidente,ListarGrupoIncidente,CrearIncidente,EditarIncidente,OcultoIncidente
}

export { GrupoIncidenteService };